/** Downloadable AON reports. Keyed by report id. aliases are legacy product codes. */
export const aliases = {
  "en": {
    "views": "Motivation factors report",
    "scales-lt-e": "English language report",
    "shapes-basic": "Work style prefrences report",
    "scales-verbal": "Verbal reasoning report",
    "scales-numerical": "Numerical reasoning report",
    "scales-lt-e-basic": "English language report",
    "scales-scales-lst": "Deductive reasoning report",
    "shapes-primary-profile": "Primary profile report",
    "shapes-behaviour-styles": "Behavioural styles report",
    "detailed-work-style-report": "Adept-15 report"
  },
  "de": {
    "views": "Bericht zu Motivationsfaktoren",
    "scales-lt-e": "Bericht zur englischen Sprache",
    "shapes-basic": "Bericht zu Arbeitsstilen",
    "scales-verbal": "Bericht zum verbalen Denken",
    "scales-numerical": "Bericht zum numerischen Denken",
    "scales-lt-e-basic": "Bericht zur englischen Sprache",
    "scales-scales-lst": "Bericht zum deduktiven Denken",
    "shapes-primary-profile": "Primary-Profile-Bericht",
    "shapes-behaviour-styles": "Bericht zu Verhaltensstilen",
    "detailed-work-style-report": "Adept-15 Bericht"
  },
  "fi": {
    "views": "Motivaatiotekijäraportti",
    "scales-lt-e": "Englannin kielen raportti",
    "shapes-basic": "Työskentelytyyliraportti",
    "scales-verbal": "Verbaalisen päättelyn raportti",
    "scales-numerical": "Numeerisen päättelyn raportti",
    "scales-lt-e-basic": "Englannin kielen raportti",
    "scales-scales-lst": "Deduktiivisen päättelyn raportti",
    "shapes-primary-profile": "Pääprofiiliraportti",
    "shapes-behaviour-styles": "Käyttäytymistyyliraportti",
    "detailed-work-style-report": "Adept-15-raportti"
  }
};

const dictionary = {
  "en": {
    "102009": {
      "id": 102009,
      "instrumentId": 102,
      "name": "Work style prefrences report",
      "languages": [
        {
          "code": 1,
          "title": "German"
        },
        {
          "code": 2,
          "title": "English"
        },
        {
          "code": 3,
          "title": "French"
        },
        {
          "code": 4,
          "title": "Italian"
        },
        {
          "code": 6,
          "title": "Norwegian"
        },
        {
          "code": 7,
          "title": "Romanian; Moldavian; Moldovan"
        },
        {
          "code": 9,
          "title": "Spanish; Castilian"
        },
        {
          "code": 10,
          "title": "Portuguese"
        },
        {
          "code": 11,
          "title": "Swedish"
        },
        {
          "code": 13,
          "title": "Polish"
        },
        {
          "code": 14,
          "title": "Czech"
        },
        {
          "code": 15,
          "title": "Russian"
        },
        {
          "code": 16,
          "title": "Danish"
        },
        {
          "code": 17,
          "title": "Finnish"
        },
        {
          "code": 18,
          "title": "Greek"
        },
        {
          "code": 19,
          "title": "Chinese"
        },
        {
          "code": 29,
          "title": "Slovak"
        }
      ]
    },
    "102048": {
      "id": 102048,
      "instrumentId": 102,
      "name": "Behavioural styles report",
      "languages": [
        {
          "code": 1,
          "title": "German"
        },
        {
          "code": 2,
          "title": "English"
        },
        {
          "code": 3,
          "title": "French"
        },
        {
          "code": 4,
          "title": "Italian"
        },
        {
          "code": 6,
          "title": "Norwegian"
        },
        {
          "code": 7,
          "title": "Romanian; Moldavian; Moldovan"
        },
        {
          "code": 9,
          "title": "Spanish; Castilian"
        },
        {
          "code": 10,
          "title": "Portuguese"
        },
        {
          "code": 15,
          "title": "Russian"
        },
        {
          "code": 19,
          "title": "Chinese"
        },
        {
          "code": 29,
          "title": "Slovak"
        }
      ]
    },
    "102066": {
      "id": 102066,
      "instrumentId": 102,
      "name": "Primary profile report",
      "languages": [
        {
          "code": 1,
          "title": "German"
        },
        {
          "code": 2,
          "title": "English"
        },
        {
          "code": 3,
          "title": "French"
        },
        {
          "code": 4,
          "title": "Italian"
        },
        {
          "code": 6,
          "title": "Norwegian"
        },
        {
          "code": 7,
          "title": "Romanian; Moldavian; Moldovan"
        },
        {
          "code": 8,
          "title": "Dutch; Flemish"
        },
        {
          "code": 9,
          "title": "Spanish; Castilian"
        },
        {
          "code": 10,
          "title": "Portuguese"
        },
        {
          "code": 11,
          "title": "Swedish"
        },
        {
          "code": 13,
          "title": "Polish"
        },
        {
          "code": 14,
          "title": "Czech"
        },
        {
          "code": 15,
          "title": "Russian"
        },
        {
          "code": 16,
          "title": "Danish"
        },
        {
          "code": 17,
          "title": "Finnish"
        },
        {
          "code": 18,
          "title": "Greek"
        },
        {
          "code": 19,
          "title": "Chinese"
        },
        {
          "code": 21,
          "title": "Arabic"
        },
        {
          "code": 29,
          "title": "Slovak"
        }
      ]
    },
    "201006": {
      "id": 201006,
      "instrumentId": 201,
      "name": "Values & Motivation result report",
      "languages": [
        {
          "code": 1,
          "title": "German"
        },
        {
          "code": 2,
          "title": "English"
        },
        {
          "code": 3,
          "title": "French"
        },
        {
          "code": 4,
          "title": "Italian"
        },
        {
          "code": 6,
          "title": "Norwegian"
        },
        {
          "code": 7,
          "title": "Romanian; Moldavian; Moldovan"
        },
        {
          "code": 8,
          "title": "Dutch; Flemish"
        },
        {
          "code": 9,
          "title": "Spanish; Castilian"
        },
        {
          "code": 10,
          "title": "Portuguese"
        },
        {
          "code": 11,
          "title": "Swedish"
        },
        {
          "code": 13,
          "title": "Polish"
        },
        {
          "code": 14,
          "title": "Czech"
        },
        {
          "code": 15,
          "title": "Russian"
        },
        {
          "code": 16,
          "title": "Danish"
        },
        {
          "code": 17,
          "title": "Finnish"
        },
        {
          "code": 18,
          "title": "Greek"
        },
        {
          "code": 19,
          "title": "Chinese"
        },
        {
          "code": 21,
          "title": "Arabic"
        },
        {
          "code": 29,
          "title": "Slovak"
        }
      ]
    },
    "301002": {
      "id": 301002,
      "instrumentId": 301,
      "name": "Numerical reasoning report",
      "languages": [
        {
          "code": 1,
          "title": "German"
        },
        {
          "code": 2,
          "title": "English"
        },
        {
          "code": 3,
          "title": "French"
        },
        {
          "code": 4,
          "title": "Italian"
        },
        {
          "code": 6,
          "title": "Norwegian"
        },
        {
          "code": 7,
          "title": "Romanian; Moldavian; Moldovan"
        },
        {
          "code": 9,
          "title": "Spanish; Castilian"
        },
        {
          "code": 10,
          "title": "Portuguese"
        },
        {
          "code": 11,
          "title": "Swedish"
        },
        {
          "code": 13,
          "title": "Polish"
        },
        {
          "code": 14,
          "title": "Czech"
        },
        {
          "code": 15,
          "title": "Russian"
        },
        {
          "code": 16,
          "title": "Danish"
        },
        {
          "code": 17,
          "title": "Finnish"
        },
        {
          "code": 18,
          "title": "Greek"
        },
        {
          "code": 19,
          "title": "Chinese"
        },
        {
          "code": 21,
          "title": "Arabic"
        },
        {
          "code": 29,
          "title": "Slovak"
        }
      ]
    },
    "302002": {
      "id": 302002,
      "instrumentId": 302,
      "name": "Verbal reasoning report",
      "languages": [
        {
          "code": 1,
          "title": "German"
        },
        {
          "code": 2,
          "title": "English"
        },
        {
          "code": 3,
          "title": "French"
        },
        {
          "code": 4,
          "title": "Italian"
        },
        {
          "code": 6,
          "title": "Norwegian"
        },
        {
          "code": 7,
          "title": "Romanian; Moldavian; Moldovan"
        },
        {
          "code": 8,
          "title": "Dutch; Flemish"
        },
        {
          "code": 9,
          "title": "Spanish; Castilian"
        },
        {
          "code": 10,
          "title": "Portuguese"
        },
        {
          "code": 11,
          "title": "Swedish"
        },
        {
          "code": 13,
          "title": "Polish"
        },
        {
          "code": 14,
          "title": "Czech"
        },
        {
          "code": 16,
          "title": "Danish"
        },
        {
          "code": 17,
          "title": "Finnish"
        },
        {
          "code": 19,
          "title": "Chinese"
        },
        {
          "code": 21,
          "title": "Arabic"
        },
        {
          "code": 29,
          "title": "Slovak"
        }
      ]
    },
    "315002": {
      "id": 315002,
      "instrumentId": 315,
      "name": "English language report",
      "languages": [
        {
          "code": 1,
          "title": "German"
        },
        {
          "code": 2,
          "title": "English"
        },
        {
          "code": 3,
          "title": "French"
        },
        {
          "code": 4,
          "title": "Italian"
        },
        {
          "code": 6,
          "title": "Norwegian"
        },
        {
          "code": 7,
          "title": "Romanian; Moldavian; Moldovan"
        },
        {
          "code": 8,
          "title": "Dutch; Flemish"
        },
        {
          "code": 9,
          "title": "Spanish; Castilian"
        },
        {
          "code": 10,
          "title": "Portuguese"
        },
        {
          "code": 11,
          "title": "Swedish"
        },
        {
          "code": 13,
          "title": "Polish"
        },
        {
          "code": 14,
          "title": "Czech"
        },
        {
          "code": 15,
          "title": "Russian"
        },
        {
          "code": 16,
          "title": "Danish"
        },
        {
          "code": 17,
          "title": "Finnish"
        },
        {
          "code": 18,
          "title": "Greek"
        },
        {
          "code": 19,
          "title": "Chinese"
        },
        {
          "code": 21,
          "title": "Arabic"
        },
        {
          "code": 29,
          "title": "Slovak"
        }
      ]
    },
    "344002": {
      "id": 344002,
      "instrumentId": 344,
      "name": "Deductive reasoning report",
      "languages": [
        {
          "code": 1,
          "title": "German"
        },
        {
          "code": 2,
          "title": "English"
        },
        {
          "code": 3,
          "title": "French"
        },
        {
          "code": 4,
          "title": "Italian"
        },
        {
          "code": 6,
          "title": "Norwegian"
        },
        {
          "code": 7,
          "title": "Romanian; Moldavian; Moldovan"
        },
        {
          "code": 8,
          "title": "Dutch; Flemish"
        },
        {
          "code": 9,
          "title": "Spanish; Castilian"
        },
        {
          "code": 10,
          "title": "Portuguese"
        },
        {
          "code": 11,
          "title": "Swedish"
        },
        {
          "code": 14,
          "title": "Czech"
        },
        {
          "code": 15,
          "title": "Russian"
        },
        {
          "code": 16,
          "title": "Danish"
        },
        {
          "code": 17,
          "title": "Finnish"
        },
        {
          "code": 21,
          "title": "Arabic"
        },
        {
          "code": 29,
          "title": "Slovak"
        }
      ]
    },
    "370002": {
      "id": 370002,
      "instrumentId": 370,
      "name": "English language report",
      "languages": [
        {
          "code": 1,
          "title": "German"
        },
        {
          "code": 2,
          "title": "English"
        },
        {
          "code": 3,
          "title": "French"
        },
        {
          "code": 4,
          "title": "Italian"
        },
        {
          "code": 6,
          "title": "Norwegian"
        },
        {
          "code": 7,
          "title": "Romanian; Moldavian; Moldovan"
        },
        {
          "code": 8,
          "title": "Dutch; Flemish"
        },
        {
          "code": 9,
          "title": "Spanish; Castilian"
        },
        {
          "code": 10,
          "title": "Portuguese"
        },
        {
          "code": 11,
          "title": "Swedish"
        },
        {
          "code": 13,
          "title": "Polish"
        },
        {
          "code": 14,
          "title": "Czech"
        },
        {
          "code": 15,
          "title": "Russian"
        },
        {
          "code": 16,
          "title": "Danish"
        },
        {
          "code": 17,
          "title": "Finnish"
        },
        {
          "code": 18,
          "title": "Greek"
        },
        {
          "code": 19,
          "title": "Chinese"
        },
        {
          "code": 21,
          "title": "Arabic"
        },
        {
          "code": 29,
          "title": "Slovak"
        }
      ]
    },
    "390004": {
      "id": 390004,
      "instrumentId": 390,
      "name": "Adept-15 result report",
      "languages": [
        {
          "code": 1,
          "title": "German"
        },
        {
          "code": 2,
          "title": "English"
        },
        {
          "code": 3,
          "title": "French"
        },
        {
          "code": 4,
          "title": "Italian"
        },
        {
          "code": 6,
          "title": "Norwegian"
        },
        {
          "code": 7,
          "title": "Romanian; Moldavian; Moldovan"
        },
        {
          "code": 8,
          "title": "Dutch; Flemish"
        },
        {
          "code": 9,
          "title": "Spanish; Castilian"
        },
        {
          "code": 10,
          "title": "Portuguese"
        },
        {
          "code": 11,
          "title": "Swedish"
        },
        {
          "code": 13,
          "title": "Polish"
        },
        {
          "code": 14,
          "title": "Czech"
        },
        {
          "code": 15,
          "title": "Russian"
        },
        {
          "code": 16,
          "title": "Danish"
        },
        {
          "code": 17,
          "title": "Finnish"
        },
        {
          "code": 18,
          "title": "Greek"
        },
        {
          "code": 19,
          "title": "Chinese"
        },
        {
          "code": 21,
          "title": "Arabic"
        },
        {
          "code": 29,
          "title": "Slovak"
        }
      ]
    },
    "390016": {
      "id": 390016,
      "instrumentId": 390,
      "name": "Adept-15 Report",
      "languages": [
        {
          "code": 1,
          "title": "German"
        },
        {
          "code": 2,
          "title": "English"
        },
        {
          "code": 3,
          "title": "French"
        },
        {
          "code": 4,
          "title": "Italian"
        },
        {
          "code": 6,
          "title": "Norwegian"
        },
        {
          "code": 7,
          "title": "Romanian; Moldavian; Moldovan"
        },
        {
          "code": 8,
          "title": "Dutch; Flemish"
        },
        {
          "code": 9,
          "title": "Spanish; Castilian"
        },
        {
          "code": 10,
          "title": "Portuguese"
        },
        {
          "code": 11,
          "title": "Swedish"
        },
        {
          "code": 13,
          "title": "Polish"
        },
        {
          "code": 14,
          "title": "Czech"
        },
        {
          "code": 15,
          "title": "Russian"
        },
        {
          "code": 16,
          "title": "Danish"
        },
        {
          "code": 17,
          "title": "Finnish"
        },
        {
          "code": 18,
          "title": "Greek"
        },
        {
          "code": 19,
          "title": "Chinese"
        },
        {
          "code": 21,
          "title": "Arabic"
        },
        {
          "code": 29,
          "title": "Slovak"
        }
      ]
    },
    "390017": {
      "id": 390017,
      "instrumentId": 390,
      "name": "Adept-15 summary report",
      "languages": [
        {
          "code": 1,
          "title": "German"
        },
        {
          "code": 2,
          "title": "English"
        },
        {
          "code": 3,
          "title": "French"
        },
        {
          "code": 4,
          "title": "Italian"
        },
        {
          "code": 6,
          "title": "Norwegian"
        },
        {
          "code": 7,
          "title": "Romanian; Moldavian; Moldovan"
        },
        {
          "code": 8,
          "title": "Dutch; Flemish"
        },
        {
          "code": 9,
          "title": "Spanish; Castilian"
        },
        {
          "code": 10,
          "title": "Portuguese"
        },
        {
          "code": 11,
          "title": "Swedish"
        },
        {
          "code": 13,
          "title": "Polish"
        },
        {
          "code": 14,
          "title": "Czech"
        },
        {
          "code": 15,
          "title": "Russian"
        },
        {
          "code": 16,
          "title": "Danish"
        },
        {
          "code": 17,
          "title": "Finnish"
        },
        {
          "code": 18,
          "title": "Greek"
        },
        {
          "code": 19,
          "title": "Chinese"
        },
        {
          "code": 21,
          "title": "Arabic"
        },
        {
          "code": 29,
          "title": "Slovak"
        }
      ]
    }
  },
  "de": {
    "102009": {
      "id": 102009,
      "instrumentId": 102,
      "name": "Arbeitsstilpräferenzen Ergebnisbericht",
      "languages": [
        {
          "code": 1,
          "title": "Deutsch"
        },
        {
          "code": 2,
          "title": "Englisch"
        },
        {
          "code": 3,
          "title": "Französisch"
        },
        {
          "code": 4,
          "title": "Italienisch"
        },
        {
          "code": 6,
          "title": "Norwegisch"
        },
        {
          "code": 7,
          "title": "Rumänisch"
        },
        {
          "code": 9,
          "title": "Spanisch"
        },
        {
          "code": 10,
          "title": "Portugiesisch"
        },
        {
          "code": 11,
          "title": "Schwedisch"
        },
        {
          "code": 13,
          "title": "Polnisch"
        },
        {
          "code": 14,
          "title": "Tschechisch"
        },
        {
          "code": 15,
          "title": "Russisch"
        },
        {
          "code": 16,
          "title": "Dänisch"
        },
        {
          "code": 17,
          "title": "Finnisch"
        },
        {
          "code": 18,
          "title": "Griechisch"
        },
        {
          "code": 19,
          "title": "Chinesisch"
        },
        {
          "code": 29,
          "title": "Slowakisch"
        }
      ]
    },
    "102048": {
      "id": 102048,
      "instrumentId": 102,
      "name": "Verhaltensstile Ergebnisbericht",
      "languages": [
        {
          "code": 1,
          "title": "Deutsch"
        },
        {
          "code": 2,
          "title": "Englisch"
        },
        {
          "code": 3,
          "title": "Französisch"
        },
        {
          "code": 4,
          "title": "Italienisch"
        },
        {
          "code": 6,
          "title": "Norwegisch"
        },
        {
          "code": 7,
          "title": "Rumänisch"
        },
        {
          "code": 9,
          "title": "Spanisch"
        },
        {
          "code": 10,
          "title": "Portugiesisch"
        },
        {
          "code": 15,
          "title": "Russisch"
        },
        {
          "code": 19,
          "title": "Chinesisch"
        },
        {
          "code": 29,
          "title": "Slowakisch"
        }
      ]
    },
    "102066": {
      "id": 102066,
      "instrumentId": 102,
      "name": "Primärprofil Ergebnisbericht",
      "languages": [
        {
          "code": 1,
          "title": "Deutsch"
        },
        {
          "code": 2,
          "title": "Englisch"
        },
        {
          "code": 3,
          "title": "Französisch"
        },
        {
          "code": 4,
          "title": "Italienisch"
        },
        {
          "code": 6,
          "title": "Norwegisch"
        },
        {
          "code": 7,
          "title": "Rumänisch"
        },
        {
          "code": 8,
          "title": "Niederländisch"
        },
        {
          "code": 9,
          "title": "Spanisch"
        },
        {
          "code": 10,
          "title": "Portugiesisch"
        },
        {
          "code": 11,
          "title": "Schwedisch"
        },
        {
          "code": 13,
          "title": "Polnisch"
        },
        {
          "code": 14,
          "title": "Tschechisch"
        },
        {
          "code": 15,
          "title": "Russisch"
        },
        {
          "code": 16,
          "title": "Dänisch"
        },
        {
          "code": 17,
          "title": "Finnisch"
        },
        {
          "code": 18,
          "title": "Griechisch"
        },
        {
          "code": 19,
          "title": "Chinesisch"
        },
        {
          "code": 21,
          "title": "Arabisch"
        },
        {
          "code": 29,
          "title": "Slowakisch"
        }
      ]
    },
    "201006": {
      "id": 201006,
      "instrumentId": 201,
      "name": "Werte & Motivation Ergebnisbericht ",
      "languages": [
        {
          "code": 1,
          "title": "Deutsch"
        },
        {
          "code": 2,
          "title": "Englisch"
        },
        {
          "code": 3,
          "title": "Französisch"
        },
        {
          "code": 4,
          "title": "Italienisch"
        },
        {
          "code": 6,
          "title": "Norwegisch"
        },
        {
          "code": 7,
          "title": "Rumänisch"
        },
        {
          "code": 8,
          "title": "Niederländisch"
        },
        {
          "code": 9,
          "title": "Spanisch"
        },
        {
          "code": 10,
          "title": "Portugiesisch"
        },
        {
          "code": 11,
          "title": "Schwedisch"
        },
        {
          "code": 13,
          "title": "Polnisch"
        },
        {
          "code": 14,
          "title": "Tschechisch"
        },
        {
          "code": 15,
          "title": "Russisch"
        },
        {
          "code": 16,
          "title": "Dänisch"
        },
        {
          "code": 17,
          "title": "Finnisch"
        },
        {
          "code": 18,
          "title": "Griechisch"
        },
        {
          "code": 19,
          "title": "Chinesisch"
        },
        {
          "code": 21,
          "title": "Arabisch"
        },
        {
          "code": 29,
          "title": "Slowakisch"
        }
      ]
    },
    "301002": {
      "id": 301002,
      "instrumentId": 301,
      "name": "Numerisches Denken Ergebnisbericht",
      "languages": [
        {
          "code": 1,
          "title": "Deutsch"
        },
        {
          "code": 2,
          "title": "Englisch"
        },
        {
          "code": 3,
          "title": "Französisch"
        },
        {
          "code": 4,
          "title": "Italienisch"
        },
        {
          "code": 6,
          "title": "Norwegisch"
        },
        {
          "code": 7,
          "title": "Rumänisch"
        },
        {
          "code": 9,
          "title": "Spanisch"
        },
        {
          "code": 10,
          "title": "Portugiesisch"
        },
        {
          "code": 11,
          "title": "Schwedisch"
        },
        {
          "code": 13,
          "title": "Polnisch"
        },
        {
          "code": 14,
          "title": "Tschechisch"
        },
        {
          "code": 15,
          "title": "Russisch"
        },
        {
          "code": 16,
          "title": "Dänisch"
        },
        {
          "code": 17,
          "title": "Finnisch"
        },
        {
          "code": 18,
          "title": "Griechisch"
        },
        {
          "code": 19,
          "title": "Chinesisch"
        },
        {
          "code": 21,
          "title": "Arabisch"
        },
        {
          "code": 29,
          "title": "Slowakisch"
        }
      ]
    },
    "302002": {
      "id": 302002,
      "instrumentId": 302,
      "name": "Verbales Denken Ergebnisbericht",
      "languages": [
        {
          "code": 1,
          "title": "Deutsch"
        },
        {
          "code": 2,
          "title": "Englisch"
        },
        {
          "code": 3,
          "title": "Französisch"
        },
        {
          "code": 4,
          "title": "Italienisch"
        },
        {
          "code": 6,
          "title": "Norwegisch"
        },
        {
          "code": 7,
          "title": "Rumänisch"
        },
        {
          "code": 8,
          "title": "Niederländisch"
        },
        {
          "code": 9,
          "title": "Spanisch"
        },
        {
          "code": 10,
          "title": "Portugiesisch"
        },
        {
          "code": 11,
          "title": "Schwedisch"
        },
        {
          "code": 13,
          "title": "Polnisch"
        },
        {
          "code": 14,
          "title": "Tschechisch"
        },
        {
          "code": 16,
          "title": "Dänisch"
        },
        {
          "code": 17,
          "title": "Finnisch"
        },
        {
          "code": 19,
          "title": "Chinesisch"
        },
        {
          "code": 21,
          "title": "Arabisch"
        },
        {
          "code": 29,
          "title": "Slowakisch"
        }
      ]
    },
    "315002": {
      "id": 315002,
      "instrumentId": 315,
      "name": "Englische Sprachfähigkeiten Ergebnisbericht",
      "languages": [
        {
          "code": 1,
          "title": "Deutsch"
        },
        {
          "code": 2,
          "title": "Englisch"
        },
        {
          "code": 3,
          "title": "Französisch"
        },
        {
          "code": 4,
          "title": "Italienisch"
        },
        {
          "code": 6,
          "title": "Norwegisch"
        },
        {
          "code": 7,
          "title": "Rumänisch"
        },
        {
          "code": 8,
          "title": "Niederländisch"
        },
        {
          "code": 9,
          "title": "Spanisch"
        },
        {
          "code": 10,
          "title": "Portugiesisch"
        },
        {
          "code": 11,
          "title": "Schwedisch"
        },
        {
          "code": 13,
          "title": "Polnisch"
        },
        {
          "code": 14,
          "title": "Tschechisch"
        },
        {
          "code": 15,
          "title": "Russisch"
        },
        {
          "code": 16,
          "title": "Dänisch"
        },
        {
          "code": 17,
          "title": "Finnisch"
        },
        {
          "code": 18,
          "title": "Griechisch"
        },
        {
          "code": 19,
          "title": "Chinesisch"
        },
        {
          "code": 21,
          "title": "Arabisch"
        },
        {
          "code": 29,
          "title": "Slowakisch"
        }
      ]
    },
    "344002": {
      "id": 344002,
      "instrumentId": 344,
      "name": "Deduktives Denken Ergebnisbericht",
      "languages": [
        {
          "code": 1,
          "title": "Deutsch"
        },
        {
          "code": 2,
          "title": "Englisch"
        },
        {
          "code": 3,
          "title": "Französisch"
        },
        {
          "code": 4,
          "title": "Italienisch"
        },
        {
          "code": 6,
          "title": "Norwegisch"
        },
        {
          "code": 7,
          "title": "Rumänisch"
        },
        {
          "code": 8,
          "title": "Niederländisch"
        },
        {
          "code": 9,
          "title": "Spanisch"
        },
        {
          "code": 10,
          "title": "Portugiesisch"
        },
        {
          "code": 11,
          "title": "Schwedisch"
        },
        {
          "code": 14,
          "title": "Tschechisch"
        },
        {
          "code": 15,
          "title": "Russisch"
        },
        {
          "code": 16,
          "title": "Dänisch"
        },
        {
          "code": 17,
          "title": "Finnisch"
        },
        {
          "code": 21,
          "title": "Arabisch"
        },
        {
          "code": 29,
          "title": "Slowakisch"
        }
      ]
    },
    "370002": {
      "id": 370002,
      "instrumentId": 370,
      "name": "Englische Sprachfähigkeiten Ergebnisbericht",
      "languages": [
        {
          "code": 1,
          "title": "Deutsch"
        },
        {
          "code": 2,
          "title": "Englisch"
        },
        {
          "code": 3,
          "title": "Französisch"
        },
        {
          "code": 4,
          "title": "Italienisch"
        },
        {
          "code": 6,
          "title": "Norwegisch"
        },
        {
          "code": 7,
          "title": "Rumänisch"
        },
        {
          "code": 8,
          "title": "Niederländisch"
        },
        {
          "code": 9,
          "title": "Spanisch"
        },
        {
          "code": 10,
          "title": "Portugiesisch"
        },
        {
          "code": 11,
          "title": "Schwedisch"
        },
        {
          "code": 13,
          "title": "Polnisch"
        },
        {
          "code": 14,
          "title": "Tschechisch"
        },
        {
          "code": 15,
          "title": "Russisch"
        },
        {
          "code": 16,
          "title": "Dänisch"
        },
        {
          "code": 17,
          "title": "Finnisch"
        },
        {
          "code": 18,
          "title": "Griechisch"
        },
        {
          "code": 19,
          "title": "Chinesisch"
        },
        {
          "code": 21,
          "title": "Arabisch"
        },
        {
          "code": 29,
          "title": "Slowakisch"
        }
      ]
    },
    "390004": {
      "id": 390004,
      "instrumentId": 390,
      "name": "Adept-15 Ergebnisbericht",
      "languages": [
        {
          "code": 1,
          "title": "Deutsch"
        },
        {
          "code": 2,
          "title": "Englisch"
        },
        {
          "code": 3,
          "title": "Französisch"
        },
        {
          "code": 4,
          "title": "Italienisch"
        },
        {
          "code": 6,
          "title": "Norwegisch"
        },
        {
          "code": 7,
          "title": "Rumänisch"
        },
        {
          "code": 8,
          "title": "Niederländisch"
        },
        {
          "code": 9,
          "title": "Spanisch"
        },
        {
          "code": 10,
          "title": "Portugiesisch"
        },
        {
          "code": 11,
          "title": "Schwedisch"
        },
        {
          "code": 13,
          "title": "Polnisch"
        },
        {
          "code": 14,
          "title": "Tschechisch"
        },
        {
          "code": 15,
          "title": "Russisch"
        },
        {
          "code": 16,
          "title": "Dänisch"
        },
        {
          "code": 17,
          "title": "Finnisch"
        },
        {
          "code": 18,
          "title": "Griechisch"
        },
        {
          "code": 19,
          "title": "Chinesisch"
        },
        {
          "code": 21,
          "title": "Arabisch"
        },
        {
          "code": 29,
          "title": "Slowakisch"
        }
      ]
    },
    "390016": {
      "id": 390016,
      "instrumentId": 390,
      "name": "Adept-15 Ergebnisbericht",
      "languages": [
        {
          "code": 1,
          "title": "Deutsch"
        },
        {
          "code": 2,
          "title": "Englisch"
        },
        {
          "code": 3,
          "title": "Französisch"
        },
        {
          "code": 4,
          "title": "Italienisch"
        },
        {
          "code": 6,
          "title": "Norwegisch"
        },
        {
          "code": 7,
          "title": "Rumänisch"
        },
        {
          "code": 8,
          "title": "Niederländisch"
        },
        {
          "code": 9,
          "title": "Spanisch"
        },
        {
          "code": 10,
          "title": "Portugiesisch"
        },
        {
          "code": 11,
          "title": "Schwedisch"
        },
        {
          "code": 13,
          "title": "Polnisch"
        },
        {
          "code": 14,
          "title": "Tschechisch"
        },
        {
          "code": 15,
          "title": "Russisch"
        },
        {
          "code": 16,
          "title": "Dänisch"
        },
        {
          "code": 17,
          "title": "Finnisch"
        },
        {
          "code": 18,
          "title": "Griechisch"
        },
        {
          "code": 19,
          "title": "Chinesisch"
        },
        {
          "code": 21,
          "title": "Arabisch"
        },
        {
          "code": 29,
          "title": "Slowakisch"
        }
      ]
    },
    "390017": {
      "id": 390017,
      "instrumentId": 390,
      "name": "Adept-15 Kurzbericht",
      "languages": [
        {
          "code": 1,
          "title": "Deutsch"
        },
        {
          "code": 2,
          "title": "Englisch"
        },
        {
          "code": 3,
          "title": "Französisch"
        },
        {
          "code": 4,
          "title": "Italienisch"
        },
        {
          "code": 6,
          "title": "Norwegisch"
        },
        {
          "code": 7,
          "title": "Rumänisch"
        },
        {
          "code": 8,
          "title": "Niederländisch"
        },
        {
          "code": 9,
          "title": "Spanisch"
        },
        {
          "code": 10,
          "title": "Portugiesisch"
        },
        {
          "code": 11,
          "title": "Schwedisch"
        },
        {
          "code": 13,
          "title": "Polnisch"
        },
        {
          "code": 14,
          "title": "Tschechisch"
        },
        {
          "code": 15,
          "title": "Russisch"
        },
        {
          "code": 16,
          "title": "Dänisch"
        },
        {
          "code": 17,
          "title": "Finnisch"
        },
        {
          "code": 18,
          "title": "Griechisch"
        },
        {
          "code": 19,
          "title": "Chinesisch"
        },
        {
          "code": 21,
          "title": "Arabisch"
        },
        {
          "code": 29,
          "title": "Slowakisch"
        }
      ]
    }
  },
  "fi": {
    "102009": {
      "id": 102009,
      "instrumentId": 102,
      "name": "Työskentelytyyliraportti",
      "languages": [
        {
          "code": 1,
          "title": "Saksa"
        },
        {
          "code": 2,
          "title": "Englanti"
        },
        {
          "code": 3,
          "title": "Ranska"
        },
        {
          "code": 4,
          "title": "Italia"
        },
        {
          "code": 6,
          "title": "Norja"
        },
        {
          "code": 7,
          "title": "Romania; Moldovia; Moldovan"
        },
        {
          "code": 9,
          "title": "Espanja; kastilia"
        },
        {
          "code": 10,
          "title": "Portugali"
        },
        {
          "code": 11,
          "title": "Ruotsi"
        },
        {
          "code": 13,
          "title": "Puola"
        },
        {
          "code": 14,
          "title": "Tšekki"
        },
        {
          "code": 15,
          "title": "Venäjä"
        },
        {
          "code": 16,
          "title": "Tanska"
        },
        {
          "code": 17,
          "title": "Suomi"
        },
        {
          "code": 18,
          "title": "Kreikka"
        },
        {
          "code": 19,
          "title": "Kiina"
        },
        {
          "code": 29,
          "title": "Slovakki"
        }
      ]
    },
    "102048": {
      "id": 102048,
      "instrumentId": 102,
      "name": "Käyttäytymistyyliraportti",
      "languages": [
        {
          "code": 1,
          "title": "Saksa"
        },
        {
          "code": 2,
          "title": "Englanti"
        },
        {
          "code": 3,
          "title": "Ranska"
        },
        {
          "code": 4,
          "title": "Italia"
        },
        {
          "code": 6,
          "title": "Norja"
        },
        {
          "code": 7,
          "title": "Romania; Moldovia; Moldovan"
        },
        {
          "code": 9,
          "title": "Espanja; kastilia"
        },
        {
          "code": 10,
          "title": "Portugali"
        },
        {
          "code": 15,
          "title": "Venäjä"
        },
        {
          "code": 19,
          "title": "Kiina"
        },
        {
          "code": 29,
          "title": "Slovakki"
        }
      ]
    },
    "102066": {
      "id": 102066,
      "instrumentId": 102,
      "name": "Pääprofiiliraportti",
      "languages": [
        {
          "code": 1,
          "title": "Saksa"
        },
        {
          "code": 2,
          "title": "Englanti"
        },
        {
          "code": 3,
          "title": "Ranska"
        },
        {
          "code": 4,
          "title": "Italia"
        },
        {
          "code": 6,
          "title": "Norja"
        },
        {
          "code": 7,
          "title": "Romania; Moldovia; Moldovan"
        },
        {
          "code": 8,
          "title": "Hollanti; flaami"
        },
        {
          "code": 9,
          "title": "Espanja; kastilia"
        },
        {
          "code": 10,
          "title": "Portugali"
        },
        {
          "code": 11,
          "title": "Ruotsi"
        },
        {
          "code": 13,
          "title": "Puola"
        },
        {
          "code": 14,
          "title": "Tšekki"
        },
        {
          "code": 15,
          "title": "Venäjä"
        },
        {
          "code": 16,
          "title": "Tanska"
        },
        {
          "code": 17,
          "title": "Suomi"
        },
        {
          "code": 18,
          "title": "Kreikka"
        },
        {
          "code": 19,
          "title": "Kiina"
        },
        {
          "code": 21,
          "title": "Arabia"
        },
        {
          "code": 29,
          "title": "Slovakki"
        }
      ]
    },
    "201006": {
      "id": 201006,
      "instrumentId": 201,
      "name": "Arvot ja motivaatio -tulosraportti",
      "languages": [
        {
          "code": 1,
          "title": "Saksa"
        },
        {
          "code": 2,
          "title": "Englanti"
        },
        {
          "code": 3,
          "title": "Ranska"
        },
        {
          "code": 4,
          "title": "Italia"
        },
        {
          "code": 6,
          "title": "Norja"
        },
        {
          "code": 7,
          "title": "Romania; Moldovia; Moldovan"
        },
        {
          "code": 8,
          "title": "Hollanti; flaami"
        },
        {
          "code": 9,
          "title": "Espanja; kastilia"
        },
        {
          "code": 10,
          "title": "Portugali"
        },
        {
          "code": 11,
          "title": "Ruotsi"
        },
        {
          "code": 13,
          "title": "Puola"
        },
        {
          "code": 14,
          "title": "Tšekki"
        },
        {
          "code": 15,
          "title": "Venäjä"
        },
        {
          "code": 16,
          "title": "Tanska"
        },
        {
          "code": 17,
          "title": "Suomi"
        },
        {
          "code": 18,
          "title": "Kreikka"
        },
        {
          "code": 19,
          "title": "Kiina"
        },
        {
          "code": 21,
          "title": "Arabia"
        },
        {
          "code": 29,
          "title": "Slovakki"
        }
      ]
    },
    "301002": {
      "id": 301002,
      "instrumentId": 301,
      "name": "Numeerisen päättelyn raportti",
      "languages": [
        {
          "code": 1,
          "title": "Saksa"
        },
        {
          "code": 2,
          "title": "Englanti"
        },
        {
          "code": 3,
          "title": "Ranska"
        },
        {
          "code": 4,
          "title": "Italia"
        },
        {
          "code": 6,
          "title": "Norja"
        },
        {
          "code": 7,
          "title": "Romania; Moldovia; Moldovan"
        },
        {
          "code": 9,
          "title": "Espanja; kastilia"
        },
        {
          "code": 10,
          "title": "Portugali"
        },
        {
          "code": 11,
          "title": "Ruotsi"
        },
        {
          "code": 13,
          "title": "Puola"
        },
        {
          "code": 14,
          "title": "Tšekki"
        },
        {
          "code": 15,
          "title": "Venäjä"
        },
        {
          "code": 16,
          "title": "Tanska"
        },
        {
          "code": 17,
          "title": "Suomi"
        },
        {
          "code": 18,
          "title": "Kreikka"
        },
        {
          "code": 19,
          "title": "Kiina"
        },
        {
          "code": 21,
          "title": "Arabia"
        },
        {
          "code": 29,
          "title": "Slovakki"
        }
      ]
    },
    "302002": {
      "id": 302002,
      "instrumentId": 302,
      "name": "Verbaalisen päättelyn raportti",
      "languages": [
        {
          "code": 1,
          "title": "Saksa"
        },
        {
          "code": 2,
          "title": "Englanti"
        },
        {
          "code": 3,
          "title": "Ranska"
        },
        {
          "code": 4,
          "title": "Italia"
        },
        {
          "code": 6,
          "title": "Norja"
        },
        {
          "code": 7,
          "title": "Romania; Moldovia; Moldovan"
        },
        {
          "code": 8,
          "title": "Hollanti; flaami"
        },
        {
          "code": 9,
          "title": "Espanja; kastilia"
        },
        {
          "code": 10,
          "title": "Portugali"
        },
        {
          "code": 11,
          "title": "Ruotsi"
        },
        {
          "code": 13,
          "title": "Puola"
        },
        {
          "code": 14,
          "title": "Tšekki"
        },
        {
          "code": 16,
          "title": "Tanska"
        },
        {
          "code": 17,
          "title": "Suomi"
        },
        {
          "code": 19,
          "title": "Kiina"
        },
        {
          "code": 21,
          "title": "Arabia"
        },
        {
          "code": 29,
          "title": "Slovakki"
        }
      ]
    },
    "315002": {
      "id": 315002,
      "instrumentId": 315,
      "name": "Englannin kielen raportti",
      "languages": [
        {
          "code": 1,
          "title": "Saksa"
        },
        {
          "code": 2,
          "title": "Englanti"
        },
        {
          "code": 3,
          "title": "Ranska"
        },
        {
          "code": 4,
          "title": "Italia"
        },
        {
          "code": 6,
          "title": "Norja"
        },
        {
          "code": 7,
          "title": "Romania; Moldovia; Moldovan"
        },
        {
          "code": 8,
          "title": "Hollanti; flaami"
        },
        {
          "code": 9,
          "title": "Espanja; kastilia"
        },
        {
          "code": 10,
          "title": "Portugali"
        },
        {
          "code": 11,
          "title": "Ruotsi"
        },
        {
          "code": 13,
          "title": "Puola"
        },
        {
          "code": 14,
          "title": "Tšekki"
        },
        {
          "code": 15,
          "title": "Venäjä"
        },
        {
          "code": 16,
          "title": "Tanska"
        },
        {
          "code": 17,
          "title": "Suomi"
        },
        {
          "code": 18,
          "title": "Kreikka"
        },
        {
          "code": 19,
          "title": "Kiina"
        },
        {
          "code": 21,
          "title": "Arabia"
        },
        {
          "code": 29,
          "title": "Slovakki"
        }
      ]
    },
    "344002": {
      "id": 344002,
      "instrumentId": 344,
      "name": "Deduktiivisen päättelyn raportti",
      "languages": [
        {
          "code": 1,
          "title": "Saksa"
        },
        {
          "code": 2,
          "title": "Englanti"
        },
        {
          "code": 3,
          "title": "Ranska"
        },
        {
          "code": 4,
          "title": "Italia"
        },
        {
          "code": 6,
          "title": "Norja"
        },
        {
          "code": 7,
          "title": "Romania; Moldovia; Moldovan"
        },
        {
          "code": 8,
          "title": "Hollanti; flaami"
        },
        {
          "code": 9,
          "title": "Espanja; kastilia"
        },
        {
          "code": 10,
          "title": "Portugali"
        },
        {
          "code": 11,
          "title": "Ruotsi"
        },
        {
          "code": 14,
          "title": "Tšekki"
        },
        {
          "code": 15,
          "title": "Venäjä"
        },
        {
          "code": 16,
          "title": "Tanska"
        },
        {
          "code": 17,
          "title": "Suomi"
        },
        {
          "code": 21,
          "title": "Arabia"
        },
        {
          "code": 29,
          "title": "Slovakki"
        }
      ]
    },
    "370002": {
      "id": 370002,
      "instrumentId": 370,
      "name": "Englannin kielen raportti",
      "languages": [
        {
          "code": 1,
          "title": "Saksa"
        },
        {
          "code": 2,
          "title": "Englanti"
        },
        {
          "code": 3,
          "title": "Ranska"
        },
        {
          "code": 4,
          "title": "Italia"
        },
        {
          "code": 6,
          "title": "Norja"
        },
        {
          "code": 7,
          "title": "Romania; Moldovia; Moldovan"
        },
        {
          "code": 8,
          "title": "Hollanti; flaami"
        },
        {
          "code": 9,
          "title": "Espanja; kastilia"
        },
        {
          "code": 10,
          "title": "Portugali"
        },
        {
          "code": 11,
          "title": "Ruotsi"
        },
        {
          "code": 13,
          "title": "Puola"
        },
        {
          "code": 14,
          "title": "Tšekki"
        },
        {
          "code": 15,
          "title": "Venäjä"
        },
        {
          "code": 16,
          "title": "Tanska"
        },
        {
          "code": 17,
          "title": "Suomi"
        },
        {
          "code": 18,
          "title": "Kreikka"
        },
        {
          "code": 19,
          "title": "Kiina"
        },
        {
          "code": 21,
          "title": "Arabia"
        },
        {
          "code": 29,
          "title": "Slovakki"
        }
      ]
    },
    "390004": {
      "id": 390004,
      "instrumentId": 390,
      "name": "Adept-15-tulosraportti",
      "languages": [
        {
          "code": 1,
          "title": "Saksa"
        },
        {
          "code": 2,
          "title": "Englanti"
        },
        {
          "code": 3,
          "title": "Ranska"
        },
        {
          "code": 4,
          "title": "Italia"
        },
        {
          "code": 6,
          "title": "Norja"
        },
        {
          "code": 7,
          "title": "Romania; Moldovia; Moldovan"
        },
        {
          "code": 8,
          "title": "Hollanti; flaami"
        },
        {
          "code": 9,
          "title": "Espanja; kastilia"
        },
        {
          "code": 10,
          "title": "Portugali"
        },
        {
          "code": 11,
          "title": "Ruotsi"
        },
        {
          "code": 13,
          "title": "Puola"
        },
        {
          "code": 14,
          "title": "Tšekki"
        },
        {
          "code": 15,
          "title": "Venäjä"
        },
        {
          "code": 16,
          "title": "Tanska"
        },
        {
          "code": 17,
          "title": "Suomi"
        },
        {
          "code": 18,
          "title": "Kreikka"
        },
        {
          "code": 19,
          "title": "Kiina"
        },
        {
          "code": 21,
          "title": "Arabia"
        },
        {
          "code": 29,
          "title": "Slovakki"
        }
      ]
    },
    "390016": {
      "id": 390016,
      "instrumentId": 390,
      "name": "Adept-15-raportti",
      "languages": [
        {
          "code": 1,
          "title": "Saksa"
        },
        {
          "code": 2,
          "title": "Englanti"
        },
        {
          "code": 3,
          "title": "Ranska"
        },
        {
          "code": 4,
          "title": "Italia"
        },
        {
          "code": 6,
          "title": "Norja"
        },
        {
          "code": 7,
          "title": "Romania; Moldovia; Moldovan"
        },
        {
          "code": 8,
          "title": "Hollanti; flaami"
        },
        {
          "code": 9,
          "title": "Espanja; kastilia"
        },
        {
          "code": 10,
          "title": "Portugali"
        },
        {
          "code": 11,
          "title": "Ruotsi"
        },
        {
          "code": 13,
          "title": "Puola"
        },
        {
          "code": 14,
          "title": "Tšekki"
        },
        {
          "code": 15,
          "title": "Venäjä"
        },
        {
          "code": 16,
          "title": "Tanska"
        },
        {
          "code": 17,
          "title": "Suomi"
        },
        {
          "code": 18,
          "title": "Kreikka"
        },
        {
          "code": 19,
          "title": "Kiina"
        },
        {
          "code": 21,
          "title": "Arabia"
        },
        {
          "code": 29,
          "title": "Slovakki"
        }
      ]
    },
    "390017": {
      "id": 390017,
      "instrumentId": 390,
      "name": "Adept-15-yhteenvetoraportti",
      "languages": [
        {
          "code": 1,
          "title": "Saksa"
        },
        {
          "code": 2,
          "title": "Englanti"
        },
        {
          "code": 3,
          "title": "Ranska"
        },
        {
          "code": 4,
          "title": "Italia"
        },
        {
          "code": 6,
          "title": "Norja"
        },
        {
          "code": 7,
          "title": "Romania; Moldovia; Moldovan"
        },
        {
          "code": 8,
          "title": "Hollanti; flaami"
        },
        {
          "code": 9,
          "title": "Espanja; kastilia"
        },
        {
          "code": 10,
          "title": "Portugali"
        },
        {
          "code": 11,
          "title": "Ruotsi"
        },
        {
          "code": 13,
          "title": "Puola"
        },
        {
          "code": 14,
          "title": "Tšekki"
        },
        {
          "code": 15,
          "title": "Venäjä"
        },
        {
          "code": 16,
          "title": "Tanska"
        },
        {
          "code": 17,
          "title": "Suomi"
        },
        {
          "code": 18,
          "title": "Kreikka"
        },
        {
          "code": 19,
          "title": "Kiina"
        },
        {
          "code": 21,
          "title": "Arabia"
        },
        {
          "code": 29,
          "title": "Slovakki"
        }
      ]
    }
  }
};

export default dictionary;
